
"use client";
import React, { useState } from 'react'; // Import useState
import Link from 'next/link';
import { Button } from '../ui/button';
import Image from 'next/image';


function Blog(props) {
    const [itemsToShow, setItemsToShow] = useState(3); // Initial number of items to show
    const handleLoadMore = () => {
        setItemsToShow(itemsToShow + 3); // Increase itemsToShow by 4
    };

    return (
        <>
            {
                props?.data.data[0]?.attributes.blogAndArticles?.data.length > 0 ?
                <div className='custom-container'>
                    <div className='xl:py-10 md:py-10'>
                        <h2 className='text-primaryBlue font-bold header1 xl:mb-8 md:mb-6 my-10 md:my-0'>{`Blogs by ${props.data.data[0].attributes.doctorName}`}</h2>
                        <div className='grid xl:grid-cols-3 md:grid-cols-3 gap-4'>
                            {props.data.data[0].attributes.blogAndArticles.data.slice(0,itemsToShow).map((e,i)=>(
                            <Link href={`/blogs-articles/${e.attributes.blogTag.replaceAll(/\s/g,'-')}`} key={i}>
                                <div className='group relative h-80 md:h-80 xl:h-96  border-solid border rounded-3xl overflow-hidden border-gray-300'>
                                    <div>
                                        <Image src={`${process.env.NEXT_PUBLIC_BE_URL}${e.attributes.blogImage.data.attributes.url}`} width={380} height={220} alt='blogs' className='relative w-full object-cover object-center h-56' />
                                    </div>
                                    <div className='absolute xl:top-[218px] top-[166px] h-full left-0 right-0 bg-white group-hover:top-0 transition-all ease-in-out duration-500'>
                                        <div className='h-20 px-4 pt-0 flex items-center '>
                                            <h3 className='text-ellipsis line-clamp-2 overflow-hidden header-sub text-gray-600'>{e.attributes.blogTitle}</h3>
                                        </div>
                                        <div className='p-4 mt-9 group-hover:mt-2 transition-all ease-in-out duration-500'>
                                            <h5 className='text-primaryGreyText p-text'>{e.attributes.blogDate}</h5>
                                            <p className='text-primaryGreyText p-text pr-2.5 xl:pt-7 md:pt-16 pt-16 group-hover:pt-1 transition-all ease-in-out duration-500'>{e.attributes.blogShortDescription}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>))}

                        </div>
                        {itemsToShow < props.data.data.length && (
                            <div className='text-center pt-6'>
                                <Button className="text-primaryWhite bg-primaryBlue hover:bg-primaryBlue uppercase rounded-full px-8 py-3 mt-2">Know More</Button>
                            </div>
                        )}
                    </div>
                </div> : null
            }
        </>
    )
}

export default Blog